import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { TabularTypeSettings } from 'app/model/dataflow/dataset-settings/tabular-type-settings';
import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.teamDesk.dataflowSettings
})
export class TeamDeskSettings extends TabularTypeSettings {
    public getDatasetType(): string {
        // for now, TeamDesk only support inline mode, it does not have dataset
        return undefined;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.TeamDesk;
    }

    public getIconClass(): string {
        return 'i-100x100-teamdesk';
    }

    public getSubFormat(): string {
        return undefined;
    }
}
